<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="cancel">
    <loading-spinner v-if="loading"></loading-spinner>
    <talking-point
      :talking-point="talking_point"
      v-else-if="talking_point"
      read-only
      v-on:cancel="cancel"
    ></talking-point>
  </v-dialog>
</template>

<script>
import TalkingPoint from "@/components/checkin/TalkingPoint";
import { mapGetters } from "vuex";
export default {
  name: "ViewTalkingPointDialog",
  components: { TalkingPoint },
  props: {},
  data: () => ({
    dialog: false,
    loading: false
  }),
  watch: {},
  computed: {
    ...mapGetters({ talking_point: "checkin/talking_point" })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    showDialog(talkingPointId) {
      this.dialog = true;
      this.loading = true;
      this.$store
        .dispatch("checkin/getTalkingPoint", talkingPointId)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while loading."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
